import React from 'react';
import Link from 'gatsby-link';
import './_sidebar.scss';
// import csv from 'csv-parser';
// import fs from 'fs';

export default class SidebarNav extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        let {children} = this.props;
        return  (
            <nav>
                <h2 className="large dark">
                    Unsere Leistungen
                </h2>
                <ul>
                    <li>
                        <Link to="/leistungen/mrt" activeClassName="plain">MRT</Link>
                    </li>
                    <li>
                        <Link to="/leistungen/ultraschall" activeClassName="plain">Ultraschall</Link>
                    </li>
                    <li>
                        <Link to="/leistungen/mammographie" activeClassName="plain">Mammographie</Link>
                    </li>
                    <li>
                        <Link to="/leistungen/roentgen" activeClassName="plain">Digitales Röntgen</Link>
                    </li>
                    <li>
                        <Link to="/leistungen/dexa" activeClassName="plain">DEXA</Link>
                    </li>
                </ul>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/sidebar/index.jsx